<template>
  <div>
      <section id="partners" >
        <b-row bg-variant="white">
          <b-col><img src="logo/airtel.png" alt="airtel" /></b-col>
          <b-col><img src="logo/tnm.png" alt="TNM" /></b-col>
          <b-col><img src="logo/taura.jpg" alt="Taura" /></b-col>
          <b-col><img src="logo/econet.jpg" alt="Econet" /></b-col>
          <b-col><img src="logo/netone.jpg" alt="Netone" /></b-col>
          <b-col><img src="logo/telecel.png" alt="Telecel" /></b-col>
          <b-col><img src="logo/mtn.png" alt="MTN" /></b-col>
          <b-col><img src="logo/vodacom.png" alt="Vodacom" /></b-col>
          <b-col><img src="logo/telkom.png" alt="Telkom" /></b-col>
          <b-col><img src="logo/cellc.png" alt="CellC" /></b-col>
        </b-row>
    </section>
      <section id="developers">
      <b-jumbotron bg-variant="white" fluid header="API for Developers">
        <p>As a developer, you can integrate Umbai's services into your own applications using our API. Our API is
          easy to use and well-documented, with a wide range of functionality including:</p>
        <ul>
          <li>Airtime top-up</li>
          <li>Data plan purchase</li>
          <li>Bill payment</li>
        </ul>
        <p>
  <a target="_blank" href="https://documentation.umbai.africa"
     class="btn btn-outline-primary btn-round btn-lg" data-toggle="tooltip"
     data-original-title="Follow us">EXPLORE THE DEVELOPER DOCS</a>
</p>
        <p>To learn more and get started, send an email to support@umbai.co.za</p>
      </b-jumbotron>
    </section>
    <section id="about">
      <b-jumbotron bg-variant="white" fluid header="About Us">
        <p>At Umbai Africa, we make cross-border shopping simple and convenient. By partnering with trusted local suppliers across Southern Africa, we allow customers to shop online for digital products like airtime and data, as well as everyday essentials, all in one place. Orders are fulfilled locally, so your goods are ready for collection in South Africa, Zimbabwe, Malawi, and beyond. Our mission is to connect shoppers with reliable local fulfilment partners, providing a seamless experience while keeping every transaction transparent and secure.</p>
      </b-jumbotron>
    </section>
    <section id="contact">
      <b-jumbotron bg-variant="white" fluid header="Contact Us">
        <b-row>
          <b-col>Call us: +27 67 740 5859 /<br /> +27 87 702 0660</b-col>
          <b-col>Whatsapp Us: +27 67 740 5859</b-col>
          <b-col>Email Us: support@umbai.co.za </b-col>
        </b-row>
      </b-jumbotron>
    </section>
    <div class="container">
      <div class="row">

        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3>
          <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4>
        </div>
        <div class="col-4 text-lg-center btn-wrapper">
          <a target="_blank" href="https://www.linkedin.com/company/umbairealities/"
            class="btn btn-neutral btn-icon-only btn-round btn-lg" data-toggle="tooltip"
            data-original-title="Follow us">
            <i class="fa fa-linkedin"></i>
          </a>
          <a target="_blank" href="https://www.facebook.com/umbai.co.za"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
            data-original-title="Like us">
            <i class="fa fa-facebook-square"></i>
          </a>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{ year }}
            Umbai all rights reserved
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Terms" class="nav-link">Terms</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Privacy" class="nav-link">Privacy</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>




